import { Text, TextProps } from "@ttc3k/trekker";
import { Box, BoxProps, Flex, FlexProps } from "styled-system/jsx";

type InlineSectionTitleProps = {
  title: string;
  containerProps?: FlexProps;
  titleProps?: TextProps;
  dividerProps?: BoxProps;
};

export const InlineSectionTitle = ({
  title,
  containerProps,
  titleProps,
  dividerProps,
}: InlineSectionTitleProps) => {
  return (
    <Flex flexDir="column" gap="100" w="fit-content" {...containerProps}>
      <Text visual="bodySemiBold" w="fit-content" {...titleProps}>
        {title}
      </Text>
      <Box
        borderBottom="2px solid"
        borderBottomColor="border.dark"
        {...dividerProps}
      />
    </Flex>
  );
};
